import React from "react";
import TopicHeaderContent from "./TopicHeaderContent";
import TopicMiddlePanes from "./TopicMiddlePanes";

class PrintTopic extends React.Component {
    render() {
        let contentModified = this.props.content.toString().replace(/<a id.+?>/g,'<a>');
      return (
          <div>
              <div className="topic-detail-header-component">
                  <div className="header">
                      <div className="header-content">
                          <TopicHeaderContent author={this.props.author} topContent={this.props.topContent} bookTitle={this.props.bookTitle} topicTitle={this.props.topicTitle} />

                      </div>
                  </div></div>
              <TopicMiddlePanes leftPane={[]} content={contentModified} rightPane={[]} />
          </div>
       
      );
    }
  }
  export default PrintTopic;